import { PersonFinal } from '@/api/entities';

/** Same notion as PersonProfile `isValidPersonId`: internal row id shapes REST often expects. */
export function isTechnicalPersonRowId(id) {
  if (!id || typeof id !== 'string') return false;
  const trimmed = id.trim();
  if (/^[a-f0-9]{24}$/i.test(trimmed)) return true;
  if (/^[a-f0-9]{8}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{12}$/i.test(trimmed)) return true;
  if (/^[a-f0-9]{32}$/i.test(trimmed)) return true;
  return false;
}

function pushUnique(list, seen, v) {
  const t = v != null ? String(v).trim() : '';
  if (!t || seen.has(t)) return;
  seen.add(t);
  list.push(t);
}

/**
 * Ordered list of path segments to try for `GET /api/personas/:id/publications`.
 * Puts Mongo/UUID-style ids first; when none are present on the persona, re-resolves via PersonFinal
 * so a business `person_id` can map to a row whose `id` is the technical key the publications route expects.
 */
export async function collectPersonPublicationPathIdCandidates(personLike, options = {}) {
  const { urlQueryId } = options;
  const list = [];
  const seen = new Set();

  const push = (v) => pushUnique(list, seen, v);

  push(personLike?.id);
  push(personLike?.person_id);
  push(personLike?._id);
  push(urlQueryId);

  const hasTechnical = list.some((x) => isTechnicalPersonRowId(x));
  if (!hasTechnical) {
    const lookupKey = String(personLike?.person_id || personLike?.id || urlQueryId || '').trim();
    if (lookupKey) {
      try {
        const rows = await PersonFinal.filter({ person_id: lookupKey }, '', 8).catch(() => []);
        const arr = Array.isArray(rows) ? rows : [];
        for (const row of arr) {
          push(row?.id);
          push(row?._id);
          push(row?.person_id);
        }
      } catch {
        /* ignore */
      }
      try {
        const byId = await PersonFinal.filter({ id: lookupKey }, '', 3).catch(() => []);
        const arr = Array.isArray(byId) ? byId : [];
        for (const row of arr) {
          push(row?.id);
          push(row?._id);
          push(row?.person_id);
        }
      } catch {
        /* ignore */
      }
    }
  }

  list.sort((a, b) => {
    const ta = isTechnicalPersonRowId(a) ? 0 : 1;
    const tb = isTechnicalPersonRowId(b) ? 0 : 1;
    return ta - tb;
  });

  return list;
}
